import { apiClient } from "../config";

async function hasUnreadNotifications() {
  const res = await apiClient.get(`/admin/notifications/has-unread`);
  return res.data;
}

export default hasUnreadNotifications;